<template>
  <v-container fluid tag="section" class="pa-0">
    <v-card class="white mb-2 pa-3 rounded-lg elevation-0" :loading="loading">
      <v-row>
        <v-col cols="12" md='2'>
           <v-select-search
            hide-details
            outlined dense
            label="年份选择"
            :data='yearItems'
            @on-change="loadData"
            item-text="label"
            item-value="value"
            v-model='form.year'>
          </v-select-search>
        </v-col>
        <v-col cols="12" md='2'>
           <v-select-search
            hide-details
            outlined dense
            label="月份选择"
            :data='monthItems'
            @on-change="loadData"
            item-text="label"
            item-value="value"
            v-model='form.month'>
          </v-select-search>
        </v-col>
         <v-col cols="12" md='2'>
           <v-select-search
            hide-details
            outlined dense
            label="状态选择"
            :data='[{label: "待主管审核", value: 0}, {label: "主管通过", value: 1}, {label: "已发放", value: 5}]'
            @on-change="loadData"
            item-text="label"
            item-value="value"
            v-model='form.status'>
          </v-select-search>
        </v-col>
        <v-col cols="12" md='2'>
          <base-marerial-user-select  @on-change="loadData" label='提交人员' hide-details outlined dense v-model="form.uids" :menu='$constants.SysMenu.SETTLE_COMMISSION_M_ID'></base-marerial-user-select>
        </v-col>
        <v-col cols="12" md='2' class="mt-c-1">
          <v-btn color="primary" :loading="loading" class="px-2" @click="loadData"><v-icon>mdi-magnify</v-icon>查询</v-btn>
        </v-col>
      </v-row>
    </v-card>
    <div class="rounded-lg white pa-3">
      实际提成 = 申请总额 - 退款提成
    </div>
    <div v-for="(data, idx) in userList" :key="idx" class="my-2">
      <v-card class="mx-auto elevation-0 py-3">
        <v-card-title class="py-1">{{data.time}}月提成结算
          <v-spacer></v-spacer>
          <span class="primary--text size-15">{{data.statusVal}}</span>
        </v-card-title>
        <v-list-item three-line>
          <v-list-item-avatar tile size="90" color="grey" class="rounded-lg">
            <v-img :src="data.avatar"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <div class="text-h5 mb-3 float-left">
              {{data.name}}
            </div>
            <v-list-item-title class="mb-2 size-15"> 申请条目数：{{data.returnNumber}} </v-list-item-title>
            <v-list-item-subtitle class="mb-3">
              <v-row>
                <v-col cols="12" md='3'>
                  回款总额：<span class="size-20 blue--text">{{data.returnMoney}}</span>
                </v-col>
                <v-col cols="12" md='3'>
                  申请总额：<span class="size-20 green--text">{{data.applyMoney}}</span>
                  <span v-if="data.manageMoney > 0" class="indigo--text size-15">&nbsp;+{{data.manageMoney}}</span>
                </v-col>
                <v-col cols="12" md='3'>
                  退款提成：<span class="size-20 red--text">{{data.refundMoney}}</span>
                </v-col>
                <v-col cols="12" md='3'>
                  实际提成：<span class="size-20 teal--text">{{(data.applyMoney - data.refundMoney + data.manageMoney).toFixed(2)}}</span>
                </v-col>
              </v-row>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-card-actions>
          <v-btn color="grey" small text @click="show(idx, data)">
            <v-icon>{{ idx === showIdx ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>{{ idx === showIdx ? '关闭回款' : '回款明细' }}
          </v-btn>
           <v-btn color="grey" small text @click="showRefund(idx, data)">
            <v-icon>{{ idx === showRefundIdx ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>{{ idx === showRefundIdx ? '关闭退款' : '退款明细' }}
          </v-btn>
          <v-spacer></v-spacer>
          <div >
            <span v-has="'service-report-back'">
              <v-btn  color='deep-orange' dark @click="showBackAll(-1, data.uid)" v-if="data.status === 0">
                {{data.uid === $store.state.userInfo.id ? '撤回' : '驳回'}}
              </v-btn>
            </span>
            &nbsp;
            <span v-has="'service-report-finance'">
              <v-btn  color='primary' class="px-2" @click="finance(1, data.uid)" v-if="data.status === 0">
                提交财务
              </v-btn>
            </span>
          </div>
          <div>
            <span v-has="'service-finance-back'">
              <v-btn  color='deep-orange' class="px-2" dark @click="showBackAll(-5, data.uid)" v-if="data.status === 1">
                驳回
              </v-btn>
            </span>
            &nbsp;
            <span v-has="'service-finance-confirm'">
              <v-btn  color='primary' class="px-2" @click="finance(5, data.uid)" v-if="data.status === 1">
                确认发放
              </v-btn>
            </span>
          </div>
        </v-card-actions>
          <v-expand-transition>
            <v-card v-if="idx === showIdx" elevation="0" class="pa-1">
              <v-card-title class="pl-1 py-1 green--text">回款信息</v-card-title>
              <base-material-table outlined :item="item" class="elevation-1" ref="returnTable" single-expand>
                 <template v-slot:expanded-content="{ headers, item, refresh }">
                    <td :colspan="headers.length" v-if='refresh' class="px-0">
                      <v-divider v-if="$isMobile"></v-divider>
                      <v-tabs v-model="tab">
                        <v-tab>合同详情</v-tab>
                      </v-tabs>
                      <v-tabs-items v-model="tab">
                        <v-tab-item>
                          <contract-view mini :item='item.contract' lazy></contract-view>
                        </v-tab-item>
                      </v-tabs-items>
                    </td>
                  </template>
              </base-material-table>
            </v-card>
          </v-expand-transition>
          <v-expand-transition>
            <v-card v-if="idx === showRefundIdx" elevation="0" class="pa-1">
              <v-card-title class="pl-1 py-1 red--text">退款信息</v-card-title>
              <base-material-table outlined :item="refundItem" ref="refundTable" class="elevation-1" single-expand>
                <template v-slot:expanded-content="{ headers, item, refresh }">
                  <td :colspan="headers.length" v-if='refresh' class="px-0">
                    <v-divider v-if="$isMobile"></v-divider>
                    <v-tabs v-model="tab">
                      <v-tab>退款详情</v-tab>
                      <v-tab>合同详情</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                      <v-tab-item>
                        <refund-view mini :item='item | formatObjectToArray'></refund-view>
                      </v-tab-item>
                      <v-tab-item>
                        <contract-view mini :item='item.contract' lazy></contract-view>
                      </v-tab-item>
                    </v-tabs-items>
                  </td>
                </template>
              </base-material-table>
            </v-card>
          </v-expand-transition>
      </v-card>
    </div>
    <base-material-simple-alert
      :show.sync='backAllModal'
      title='驳回/撤回提示'
      @on-submit='backAll'
      >
      <template v-slot:content>
        <v-row>
          <v-col cols="12">
            <v-textarea rows='4' label="备注信息" hide-details='auto' outlined v-model="subForm.remark"></v-textarea>
          </v-col>
        </v-row>
      </template>
    </base-material-simple-alert>
     <base-material-simple-alert
      :show.sync='backModal'
      title='驳回/撤回提示'
      @on-submit='back'
      >
      <template v-slot:content>
        <v-row>
          <v-col cols="12">
            <v-textarea rows='4' label="备注信息" hide-details='auto' outlined v-model="subForm.remark"></v-textarea>
          </v-col>
        </v-row>
      </template>
    </base-material-simple-alert>
  </v-container>
</template>

<script>
  import VSelectSearch from '@/components/select/v-select-search.vue'
  import { users, serviceBack, serviceSave } from '@/api/contract/settle.js'
  import { applyBack } from '@/api/contract/returned.js'
  import { selectData2, selectMonthData } from '@/utils/tool.js'
  import ContractView from '@/views/pages/pc/contract/info/components/Detail.vue'
  import RefundView from '@/views/pages/pc/contract/refund/components/Detail.vue'

  export default {
    name: 'ServiceSettleIndex',
    components: {
      VSelectSearch,
      ContractView,
      RefundView
    },
    data() {
      return {
        tab: 0,
        userList: [],
        form: {
          status: this.$_has('service-finance-confirm') ? 1 : ''
        },
        subForm: {},
        showIdx: -1,
        showRefundIdx: -1,
        loading: false,
        monthItems: selectMonthData(),
        yearItems: selectData2(),
        backModal: false,
        backAllModal: false,
        item: {
          mobile: true,
          path: 'service/settle/list',
          params: {
            uid: '',
            returnTime: [],
            createMonth: ''
          },
          sort: {
            orderByField: 'create_time',
            asc: false
          },
          headers: [
            {
              text: '详情',
              align: 'center',
              divider: true,
              width: 60,
              class: 'fixed-left',
              cellClass: 'fixed-left',
              value: '',
              sortable: false,
              mobile: true,
              icon: {
                value: 'mdi-dots-horizontal',
                onClick: (row, idx) => {
                  this.$refs.returnTable[0].showMore(row, idx)
                }
              }
            },
            {
              text: '客户名称',
              align: 'center',
              divider: true,
              mobile: true,
              width: 200,
              copy: true,
              value: 'customer.name',
              sortable: false,
              formatter: (val) => val || '--'
            },
            {
              text: '产品名称',
              align: 'center',
              divider: true,
              width: 210,
              copy: true,
              value: 'product.name',
              sortable: false,
              formatter: (val) => val || '--'
            },
            {
              text: '合同编号',
              align: 'center',
              divider: true,
              width: 210,
              copy: true,
              mobile: true,
              value: 'contract.serialNumber',
              sortable: false,
              formatter: (val) => val || '--'
            },
            {
              text: '回款日期',
              align: 'center',
              divider: true,
              width: 120,
              value: 'returned.returnTime',
              sortable: false,
              formatter: (val) => (val ? this.$moment(val * 1000).format('YYYY-MM-DD') : '--')
            },
            {
              text: '回款类型',
              align: 'center',
              divider: true,
              width: 120,
              value: 'returned.returnTypeDic.name',
              sortable: false,
              formatter: (val) => val || '--'
            },
            {
              text: '人员级别',
              align: 'center',
              divider: true,
              width: 90,
              mobile: true,
              value: 'contract.levelDic.name',
              sortable: false,
              formatter: (val) => val || '--'
            },
            {
              text: '收款金额',
              align: 'center',
              divider: true,
              value: 'returned.money',
              mobile: true,
              width: 120,
              sortable: false,
              formatter: (val) => val || 0
            },
            {
              text: '本次居间',
              align: 'center',
              divider: true,
              value: 'returned.mediatorPrice',
              mobile: true,
              width: 110,
              sortable: false,
              // formatter: (val, row) => row.contract ? (val * (row.contract.mediatorPrice / row.contract.signPrice)) : 0
            },
            {
              text: '提成比例',
              align: 'center',
              divider: true,
              width: 90,
              value: 'contract.commissionRatio',
              sortable: false,
              mobile: true,
              formatter: (val) => (val ? `${val}%` : '--')
            },
            {
              text: '本次提成',
              align: 'center',
              divider: true,
              value: 'money',
              width: 120,
              mobile: true,
              sortable: false
            },
            {
              text: '渠道名称',
              align: 'center',
              divider: true,
              value: 'contract.channelName',
              width: 150,
              sortable: false,
              mobile: true,
              formatter: (val) => val || '--'
            },
            {
              text: '创建人',
              align: 'center',
              divider: true,
              value: 'createUser.name',
              width: 120,
              sortable: false
            },
            {
              text: '创建时间',
              align: 'center',
              value: 'createTime',
              width: 120,
              sortable: false,
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            {
              text: '操作',
              value: 'actions',
              align: 'center',
              sortable: false,
              width: 100,
              class: 'fixed-right',
              cellClass: 'fixed-right',
              mobile: true,
              actions: [
                {
                  text: '撤回',
                  color: 'primary',
                  icon: 'mdi-charity',
                  onClick: (row) => {
                    console.log(row)
                    this.showBack({ status: -10, returnedId: row.returnedId, settleId: row.id })
                  },
                  disable: (row) => row.status !== 0 || row.createUserId !== this.$store.state.userInfo.id
                },
                {
                  text: '驳回',
                  color: 'primary',
                  icon: 'mdi-charity',
                  onClick: (row) => {
                    this.showBack({ status: -1, returnedId: row.returnedId, settleId: row.id })
                  },
                  disable: (row) => row.status !== 0 || !this.$_has('service-report-back') || row.createUserId === this.$store.state.userInfo.id
                },
                {
                  text: '驳回',
                  color: 'primary',
                  icon: 'mdi-charity',
                  onClick: (row) => {
                    this.showBack({ status: -5, returnedId: row.returnedId, settleId: row.id })
                  },
                  disable: (row) => row.status !== 1 || row.status === 5 || !this.$_has('service-finance-back')
                }
              ]
            }
          ]
        },
        refundItem: {
          mobile: true,
          path: 'contract/refund/info/list',
          params: {
            userIds: [],
            createTimes: [],
            auditStatus: [1],
            isBackMoney: 1
          },
          sort: {
            orderByField: 'create_time',
            asc: false
          },
          headers: [
            {
              text: '详情',
              align: 'center',
              divider: true,
              width: 60,
              class: 'fixed-left',
              cellClass: 'fixed-left',
              value: '',
              sortable: false,
              mobile: true,
              icon: {
                value: 'mdi-dots-horizontal',
                onClick: (row, idx) => {
                  this.$refs.refundTable[0].showMore(row, idx)
                }
              }
            },
            {
              text: '客户名称',
              align: 'center',
              divider: true,
              width: 200,
              value: 'customer.name',
              mobile: true,
              copy: true,
              sortable: false
            },
            {
              text: '审核状态',
              align: 'center',
              divider: true,
              width: 120,
              value: 'order',
              sortable: false,
              mobile: true,
              formatter: (val) => val.auditStatusVal
            },
            {
              text: '流水号',
              align: 'center',
              divider: true,
              width: 180,
              copy: true,
              value: 'refundNumber',
              sortable: false
            },
            {
              text: '合同编号',
              align: 'center',
              divider: true,
              width: 190,
              mobile: true,
              copy: true,
              value: 'contract.serialNumber',
              sortable: false
            },
            {
              text: '退款金额',
              align: 'center',
              divider: true,
              width: 120,
              value: 'money',
              mobile: true,
              sortable: false
            },
            {
              text: '提成比例',
              align: 'center',
              divider: true,
              width: 120,
              value: 'contract.commissionRatio',
              mobile: true,
              sortable: false,
              formatter: (val) => `${val}%`
            },
            {
              text: '退款提成',
              align: 'center',
              divider: true,
              width: 120,
              value: 'money',
              mobile: true,
              sortable: false,
              span: {
                color: () => 'red',
                formatter: (val, row) => ((val - val * (row.contract.mediatorPrice / row.contract.signPrice)) * (row.contract.commissionRatio / 100)).toFixed(2)
              }
            },
            {
              text: '退款原因',
              align: 'center',
              divider: true,
              width: 120,
              mobile: true,
              value: 'refundTypeDic.name',
              sortable: false
            },
            {
              text: '申请人',
              align: 'center',
              divider: true,
              value: 'createUser.name',
              mobile: true,
              width: 120,
              sortable: false
            },
            {
              text: '创建时间',
              align: 'center',
              value: 'createTime',
              width: 120,
              mobile: true,
              sortable: false,
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            }
          ]
        }
      }
    },
    methods: {
      show (idx, data) {
        this.showIdx = this.showIdx === idx ? -1 : idx
        this.item.params.uid = data.uid
        this.item.params.createMonth = data.time
      },
      showRefund (idx, data) {
        this.showRefundIdx = this.showRefundIdx === idx ? -1 : idx
        this.refundItem.params.userIds[0] = data.mdUserId
        this.refundItem.params.createTimes = [`${data.time}-11`, `${this.$moment(data.time).add(1, 'month').format('YYYY-MM')}-11`]
      },
      showBackAll (status, createUserId) {
        this.subForm = { status, createUserId }
        this.backAllModal = true
      },
      showBack (from) {
        this.subForm = from
        this.backModal = true
      },
      finance (status, createUserId) {
        const tip = status === 1 ? '提交财务' : '发放提成'
        this.$dialog.confirm({
          text: `确认【${tip}】吗?`,
          title: '系统提示',
          width: 300,
          actions: {
            false: { color: 'grey', text: '取消' },
            true: {
              color: 'primary',
              text: '确认',
              handle: () => new Promise(resolve => {
                serviceSave({ status, createUserId }).then(response => {
                  if (response.status === 200) {
                    this.loadData()
                    this.$dialog.notify.success(`${tip}成功`, { position: 'top-right', timeout: 4000 })
                  }
                  resolve(response)
                })
              })
            }
          }
        })
      },
      backAll () {
        serviceBack(this.subForm).then(res => {
          if (res.status === 200) {
            this.backAllModal = false
            this.loadData()
            this.showIdx = false
          }
        })
      },
      back () {
        applyBack(this.subForm).then(res => {
          if (res.status === 200) {
            this.backModal = false
            this.loadData()
            this.showIdx = false
          }
        })
      },
      loadData () {
        this.loading = true
        users(this.form).then(res => {
          if (res.status === 200) {
            this.userList = res.data
          }
          this.loading = false
        })
      }
    },
    created () {
      this.loadData()
    }
  }
</script>

<style>
</style>
